import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const ImageWrapper = styled(Flex).attrs({
  flex: 'none',
  align: 'center',
  justify: 'center',
})`
  border-radius: 50%;
  width: ${props => props.width};
  height: ${props => props.height};

  & div {
    display: none;
    border-radius: 50%;
    width: ${props => props.width};
    height: ${props => props.height};
    position: absolute;
    background-color: #eee;
  }

  &:hover div {
    display: flex;
    opacity: 0.7;
  }

  & > svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  & > img {
    border-radius: 50%;
    width: ${props => props.width};;
    height: ${props => props.height};;
  }

  & input[type=file] {
    width: ${props => props.width};
    height: ${props => props.height};
    position: absolute;
    border-radius: 50%;
    opacity: 0;
    cursor: pointer;
    z-index: 9999;
  }
  ${props => props.isEmpty && `
    & div {
      display: flex;
    }
  `};
`;

export const Image = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const Progress = styled.div`
  border: 5px solid #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const UploadText = styled(Flex).attrs({
  column: true,
  align: 'center',
  justify: 'center',
})`
  color: ${props => props.theme.colors.link};
  cursor: pointer;
  font-size: 12px;
  text-transform: uppercase;
`;
